import Button from 'components/Button/Button';
import { ChevronRightIcon } from 'components/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

const LearnMore = (props) => {
  const [t] = useTranslation('senderProfile');
  return (
    <a
      href="https://help.textinchurch.com/en/articles/7670784-sender-profile-us-accounts-only"
      target="_blank"
    >
      <Button fullWidth endIcon={<ChevronRightIcon />} {...props}>
        {t('learn-more', 'Learn more about A2P 10-DLC')}
      </Button>
    </a>
  );
};

export default LearnMore;
